import { Link } from "react-router-dom";
import { Star, CircleCheckBig } from "lucide-react";
import RankBadge from "../social/RankBadge";
import Avatar from "./Avatar";

export default function UserChip({ user, link = true }) {
  const content = (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <Avatar user={user} size="sm" />
      <span className="font-medium text-walnut">{user.display_name}</span>
      {user.is_verified && <CircleCheckBig size={14} className="text-terracotta" />}
      <RankBadge rank={user.rank} />
      {user.rating_avg != null && (
        <span className="inline-flex items-center gap-0.5 text-xs text-walnut-light">
          <Star size={12} className="fill-amber text-amber" />
          {user.rating_avg.toFixed(1)}
          <span>({user.rating_count})</span>
        </span>
      )}
    </span>
  );

  if (!link) return content;
  return (
    <Link to={`/users/${user.id}`} className="hover:underline">
      {content}
    </Link>
  );
}
